// Activity logging utility for frontend
import tokenManager from './tokenManager';

export const logActivity = async (action, entityType = null, entityId = null, details = null, extraData = null) => {
  try {
    // Get current user info from localStorage
    const token = tokenManager.getToken();
    if (!token) return; // No user logged in
    
    // Make API call to log activity
    await fetch('/api/log-activity', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        action,
        entity_type: entityType,
        entity_id: entityId,
        details,
        ...extraData
      })
    });
  } catch (error) {
    console.error('Failed to log activity:', error);
    // Don't throw error - logging failures shouldn't break the main action
  }
};

export const undoInventoryAction = async (action, undoData) => {
  try {
    let endpoint = '';
    let payload = {};
    
    switch (action) {
      case 'delete_inventory_sheet':
        endpoint = '/api/inventory/undo/sheet';
        payload = undoData;
        break;
      case 'delete_inventory_item':
        endpoint = '/api/inventory/undo/item';
        payload = undoData;
        break;
      case 'update_inventory_item':
        // For updates, we can directly restore the old value
        // This would need to be handled by refreshing the inventory view
        return { success: true, needsRefresh: true };
      default:
        throw new Error(`Unsupported undo action: ${action}`);
    }
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Failed to undo inventory action');
    }

    return await response.json();
  } catch (error) {
    console.error('Error undoing inventory action:', error);
    throw error;
  }
};